module.exports = __webpack_public_path__ + "img/camera.24d957bd.svg";